<script lang="ts">
    import { Card, Button } from "flowbite-svelte";
    import SalesCardIcons from "./SalesCardIcons.svelte";
    import { createEventDispatcher } from "svelte";
    import {IconOutline} from "flowbite-svelte-icons";

    export let card
    const dispatch = createEventDispatcher();
    const handleSelection = (value: string) => {
        dispatch('cardSelected', { value })
    }
</script>
<Card  class="w-full max-w-full flex flex-col items-center gap-y-4 {card.selected ? '' : ''}" >
    <SalesCardIcons cardIcon={card.cardIcon} />
    <h3 class="text-2xl leading-7 text-neutral-600">{card.name}</h3>
    <div class="text-center text-neutral-600">{card.tagline}</div>
    <div class="grid h-[300px] place-items-start">
        {#each card.options as option}
            <Button
                color="none"
                class="hover:bg-primary-600 {card.valueSelected === option.value ? 'bg-primary-600 text-white hover:text-white' : ''}"
                bind:value={option.value}
                on:click={() => handleSelection(option.value)}
            >
                {@html option.value}
            </Button>
        {/each}
    </div>
</Card>
